export default "__VITE_ASSET__Dfc96ACv__"